var innerRemote;
function attachRemote () {
	innerRemote = __webpack_require__("U2qs");
	var gs = __webpack_require__.g || globalThis
	gs["hhgDiscoverV1"] = innerRemote
	return innerRemote;
};
attachRemote();